<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
              <b-col cols="6">
                <ValidationProvider name="program" rules="required" v-slot="{ errors }">
                  <b-form-group :label="$t('program')">
                    <program-selectbox
                        level="E"
                        v-model="formData.program_code"
                        :validate-error="errors[0]"
                    />
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="6">
                <b-form-group :label="$t('program_codes')">
                  <program-selectbox
                      level="E"
                      v-model="formData.program_codes"
                      :multiple="true"
                  />
                </b-form-group>
              </b-col>
                <b-col cols="6" md="4" lg="6">
                    <ValidationProvider name="level" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('level')">
                           <EslLevelSelectbox
                             v-model="formData.level_id"
                             :validate-error="errors[0]"
                           />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6" md="8" lg="6">
                    <b-form-group :label="$t('name')">
                        <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                            <b-input-group class="mb-1">
                                <b-form-input v-model="formData.name" :state="errors[0] ? false : null"/>
                            </b-input-group>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6" md="4" lg="6">
                    <ValidationProvider name="days_in_a_week" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('days_in_a_week')">
                            <ParameterSelectbox
                                v-model="formData.days_in_a_week"
                                :multiple="true"
                                code="days_in_a_week"
                                sort="rank"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6" md="8" lg="6">
                    <ValidationProvider name="days_of_the_week" rules="required" v-slot="{ errors }">
                    <b-form-group :label="$t('days_of_the_week')">

                                <ParameterSelectbox
                                    v-model="formData.days_of_the_week"
                                    :multiple="true"
                                    code="days"
                                    sort="code"
                                />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>

                    </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6" md="4" lg="6">
                    <ValidationProvider name="hours_in_a_day" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('hours_in_a_day')">
                            <b-form-input type="number" v-model="formData.hours_in_a_day" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
              <b-col cols="6" md="4" lg="6">
                    <ValidationProvider name="hours_in_a_day_for_attendance" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('hours_in_a_day_for_attendance')">
                            <b-form-input type="number" v-model="formData.hours_in_a_day_for_attendance" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6" md="8" lg="6">
                    <b-form-group :label="$t('part_of_the_day')">
                        <ValidationProvider name="part_of_the_day" rules="required" v-slot="{ errors }">
                                <ParameterSelectbox
                                    v-model="formData.part_of_the_day"
                                    code="part_of_the_day"
                                />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="6" md="8" lg="6">
                    <ValidationProvider name="status" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <status-selectbox
                                v-model="formData.status"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="createForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components


// Services
import EslCourseService from "@/services/EslCourseService";

import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import EslLevelSelectbox from "../../../components/interactive-fields/EslLevelSelectbox.vue";
import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";

export default {
    components: {
        EslLevelSelectbox,
        StatusSelectbox,
        ParameterSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            formData: {
                program_code: null,
                program_codes: [],
                level_id: null,
                name: null,
                days_in_a_week: null,
                days_of_the_week: null,
                hours_in_a_day: null,
                hours_in_a_day_for_attendance: null,
                part_of_the_day: null,
                status: null,
            },
            formLoading: false,
        }
    },
    methods: {
        async createForm() {
            if (this.checkPermission('eslcourse_store')) {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid) {
                    this.formData.days_in_a_week = parseInt(this.formData.days_in_a_week)
                    this.formLoading = true;
                    EslCourseService.store(this.formData)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.$emit('createFormSuccess', true);
                        })
                        .catch(e => {
                            this.showErrors(e);
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>

